import React, { useState, useEffect } from "react";
import { useTheme } from '../../ThemeContext';
import moment from 'moment'; // Import moment.js
import { getDocVersions } from "../../api/api";
import ViewFileType from "../ViewFileType";
const DocumentVersions = ({ file, project_id, folderPath }) => {
  console.log(file,folderPath)
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [versions, setVersions] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // Track the selected file

  useEffect(() => {
    const fetchVersions = async () => {
      try {
        const response = await getDocVersions({ projectId: project_id, folderPath: folderPath, fileName: file });
        setVersions(response.data.files);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching document versions:", error);
      }
    };

    fetchVersions();
  }, [project_id, folderPath, file]); // Added dependencies to re-fetch when props change

  // Sort the versions in descending order to display the latest version first
  const sortedVersions = [...versions].reverse();

  const handleFileClick = (fileName) => {
    setSelectedFile(fileName);
    setOpen(true); // Open the viewer when a file is selected
  };

  return (
    <div className={`w-full mx-auto mt-8 p-6 rounded-lg shadow-md ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
      <h2 className={`text-2xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-700'}`}>
        Document Versions
      </h2>
      <div className="overflow-x-auto">
        <table className={`table-auto w-full border-collapse border ${isDark ? 'border-gray-600' : 'border-gray-300'}`}>
          <thead>
            <tr className={`${isDark ? 'bg-gray-700' : 'bg-gray-100'}`}>
              <th className={`border px-4 py-2 text-left ${isDark ? 'text-gray-200' : 'text-gray-600'}`}>
                Version
              </th>
              <th className={`border px-4 py-2 text-left ${isDark ? 'text-gray-200' : 'text-gray-600'}`}>
                Timestamp
              </th>
              <th className={`border px-4 py-2 text-left ${isDark ? 'text-gray-200' : 'text-gray-600'}`}>
                Updated By
              </th>
              <th className={`border px-4 py-2 text-left ${isDark ? 'text-gray-200' : 'text-gray-600'}`}>
                Change Description
              </th>
              <th className={`border px-4 py-2 text-left ${isDark ? 'text-gray-200' : 'text-gray-600'}`}>
                File Name
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedVersions.map((version) => (
              <tr key={version.version} className={`hover:bg-gray-50 ${isDark ? 'hover:bg-gray-600' : ''}`}>
                <td className={`border px-4 py-2 ${isDark ? 'text-white' : 'text-gray-800'}`}>
                  Version {version.version}
                </td>
                <td className={`border px-4 py-2 ${isDark ? 'text-white' : 'text-gray-800'}`}>
                  {moment(version.createdAt).fromNow()} {/* Format timestamp */}
                </td>
                <td className={`border px-4 py-2 ${isDark ? 'text-white' : 'text-gray-800'}`}>
                  {version.updatedBy}
                </td>
                <td className={`border px-4 py-2 ${isDark ? 'text-white' : 'text-gray-800'}`}>
                  {version.description}
                </td>
                <td className={`border px-4 py-2 ${isDark ? 'text-white' : 'text-gray-800'}`}>
                  <p
                    onClick={() => handleFileClick(version)} // Pass file name to handler
                    className="cursor-pointer text-blue-500 hover:text-blue-700"
                  >
                    {version.fileName} {/* Display the file name */}
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ViewFileType
        open={open}
        onClose={() => setOpen(false)}
        file={selectedFile}
        projectId={project_id}
      />
    </div>
  );
};

export default DocumentVersions;
